// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(-18)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(0)),
            BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(-10)),
            BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(-10)),
            BsCssJs$PrezzeeRibbon.flexDirection("row")
          ])
    ]);

var tileContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(18)),
      BsCssJs$PrezzeeRibbon.flex({
            NAME: "num",
            VAL: 1
          }),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(0)),
            BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(10)),
            BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(10))
          ])
    ]);

var Styles = {
  wrapper: wrapper,
  tileContainer: tileContainer
};

function PromoTiles(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var tiles = React.Children.toArray(props.children);
  var individualTiles = Belt_Array.mapWithIndex(tiles, (function (i, tile) {
          return JsxRuntime.jsx("div", {
                      children: tile,
                      className: tileContainer
                    }, String(i));
        }));
  return JsxRuntime.jsx("div", {
              children: individualTiles,
              className: Classnames([
                    wrapper,
                    className$1
                  ])
            });
}

var make = PromoTiles;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
